import React, { ReactNode } from 'react';
import './Modal.scss';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  className?: string;
  hideCloseButton?: boolean;
  blockOverlayClick?: boolean;
}

export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  className = '',
  hideCloseButton = false,
  blockOverlayClick = false,
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = () => {
    if (!blockOverlayClick) {
      onClose();
    }
  };

  return (
    <div className={`modal ${className}`}>
      <div className="modal__overlay" onClick={handleOverlayClick} />
      <div className="modal__container">
        {!hideCloseButton && (
          <button
            className="modal__close"
            onClick={onClose}
            aria-label="Close modal"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        )}
        <div className="modal__content">
          {children}
        </div>
      </div>
    </div>
  );
};

